import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskWeight(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={(e) => {
        props.onChange({
          target: {
            value: e.target.value,
          },
        });
      }}
      mask="999 pounds"
      maskChar=" "
    />
  );
}

InputMaskWeight.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskWeight.js